export default function (platform) {
  switch (platform) {
    case 'messenger':
    case 'instagram':
    case 'instagram_dm':
      return 'facebook'
    case 'twitterDM':
      return 'twitter'
    case 'twitter':
    case 'facebook':
    case 'shopify':
      return platform
    case 'h4mail':
      return 'google'
    default:
      return undefined
  }
}
